<template>
  <div class="home_page">
    <Breadcrumb :pageTitle="pageTitle" />
    <div class="home_header">
      <StatusTabs
        :tabList="tabList"
        :curStatus="activited"
        :tableConfig="tableConfig"
        @changeStatusHandle="changeStatusHandle"
      >
        <div slot="operation">
          <el-button
            type="primary"
            @click="downLoad"
            v-show="activited === '02'"
            :loading="downloadLoading"
            icon="el-icon-download"
            >导出明细</el-button
          >
        </div>
      </StatusTabs>
    </div>
    <div class="toTop" v-show="gotop" @click="toTop">
      <!-- <img width="24px"
           src="../../../../assets/img/lclb/toTop.png"
           alt="" /> -->
      回顶部
    </div>
    <el-row class="goods_category_list searchBox" ref="searchBox">
      <el-col :span="activited !== '03' ? 6 : 12">
        <el-input
          placeholder="名称/品牌/编码/型号"
          v-model.trim="dataForm.searchInput"
          clearable
          @keyup.enter.native="onSearch"
        ></el-input>
      </el-col>
      <el-col :span="6" class="screah" v-if="activited !== '03'">
        <el-input
          placeholder="平台编码"
          v-model.trim="dataForm.goodsCode"
          clearable
          @keyup.enter.native="onSearch"
        ></el-input>
      </el-col>
      <el-col :span="6" class="screah">
        <el-select
          clearable
          v-model.trim="dataForm.skuAvailableStatus"
          placeholder="上架状态"
          @keyup.enter.native="onSearch"
        >
          <el-option
            v-for="item in skuAvailableStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="screah">
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="resetData">重置</el-button>
      </el-col>
    </el-row>
    <div class="goods_category_list">
      <el-table
        :data="dataList"
        ref="multipleTable"
        v-loading="dataListLoading"
        :key="`table_${activited}`"
        :row-key="getRowKeys"
        @sort-change="onSortChange"
      >
        <template slot="empty">
          <img src="@/assets/img/good/noGood.png">
          <div>暂无数据</div>
        </template>
        <el-table-column
          header-align="center"
          align="center"
          label="备件信息"
          width="280"
        >
          <template slot-scope="scope">
            <div class="detail">
              <el-image
                :src="scope.row.goodsUrl"
                class="goodsImg"
                :preview-src-list="[scope.row.goodsUrl]"
              >
                <div slot="error">
                  <img src="~@/assets/img/bitmap.png" class="goodsImg" />
                </div>
              </el-image>
              <div class="mask" v-if="scope.row.skuStatus != 5">未上架</div>
              <div class="info">
                <h3
                  class="tooltip-wrap oldGoodsName"
                  @click="goodDetailHandle(scope.row)"
                  v-if="scope.row.skuStatus == 5"
                >
                  <Tooltip :text="scope.row.oldGoodsName | isEmpty" />
                </h3>
                <h3 class="tooltip-wrap" v-else>
                  <Tooltip :text="scope.row.oldGoodsName | isEmpty" />
                </h3>
                <div class="tooltip-wrap">
                  型号：<Tooltip :text="scope.row.oldSpecification | isEmpty" />
                </div>
                <div class="tooltip-wrap">
                  规格：<Tooltip :text="scope.row.oldModel | isEmpty" />
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="备件编码"
          width="120"
          prop="oldGoodsCode"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.oldGoodsCode | isEmpty }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="平台编码"
          width="120"
          prop="goodsCode"
          v-if="['02', '01', '04'].includes(activited)"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.goodsCode | isEmpty }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="品牌"
          prop="brand"
        >
          <template slot-scope="scope">
            <span v-if="activited === '03'">{{ scope.row.oldBrand | isEmpty }}</span>
            <span v-else>{{ scope.row.brand | isEmpty }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="包装规格"
          width="120px"
        >
          <template slot-scope="scope">
            {{ scope.row.packingInfo }}
            <el-tooltip class="item" effect="dark" content="销售单位含物理单位的数量" placement="top-start">
              <div class="el-icon-question"></div>
            </el-tooltip><br />
            起订量{{ scope.row.moq || 1 }}{{ scope.row.sellingUnit }}<br />
            步长{{ scope.row.sellingUnitStepSize || 1 }}{{ scope.row.sellingUnit }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="单价(元)"
          width="120"
          prop="price"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.price | formatePrice4 }} / {{ scope.row.sellingUnit || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="备件数量"
          width="120"
          prop="safetyStockQuantity"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.safetyStockQuantity | isEmpty }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="activited === '02'"
          header-align="center"
          align="center"
          width="110"
          label="数量"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.skuStatus == 5"
              placement="top"
              :content="
                `起订量${scope.row.moq || 1}, 步长${scope.row
                  .sellingUnitStepSize || 1}`
              "
            >
              <el-input-number
                class="numInput"
                v-model="scope.row.goodsNum"
                @change="onChangeGoodsNum(scope.row)"
                controls-position="right"
                :min="
                  getMin(+scope.row.moq || 1, +scope.row.sellingUnitStepSize || 1)
                "
                :step="+scope.row.sellingUnitStepSize || 1"
                :max="99999999"
              ></el-input-number>
            </el-tooltip>
            <div v-else>-</div>
            {{ scope.row.sellingUnit }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="activited !== '02'"
          header-align="center"
          align="center"
          width="110"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="btns">
              <el-button
                class="btn"
                type="primary"
                size="small"
                v-if="scope.row.buttonFlag !== 'BY'"
                @click="joinShopCart(scope.row)"
              >
                加入领用车
              </el-button>
              <!-- <el-button
                class="btn"
                type="primary"
                size="small"
                @click="openDetailUpdate(scope.row)"
              >
                {{ scope.row.buttonFlag === "BY" ? "备用" : "领用" }}
              </el-button> -->
              <el-button
                class="btn"
                type="primary"
                size="small"
                @click="goodDetailHandle(scope.row)"
                v-if="activited !== '02' && scope.row.skuStatus === 5"
              >
                详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_end">
      <el-pagination
        :current-page="dataForm.page"
        :page-size="dataForm.limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <div ref="account" v-if="activited === '02'">
      <div
        class="accountBox home_page"
        ref="accountBox"
        :class="{ 'accountBox-fixed': isShowAccountFooter }"
      >
        <div class="numPrice">
          {{ `已选择${account.type}种, 共${account.num}件, 总价：`
          }}<span class="red">￥{{ account.price | formatePrice4 }}</span>
        </div>
        <el-button type="primary" plain @click="receiveHandle"
          >直接领用</el-button
        >
        <el-button type="primary" @click="batchAddCar">加入领用车</el-button>
      </div>
    </div>

    <div class="topSearch" ref="topSearch" v-show="isShowFakeTableHeader">
      <div class="home_page">
        <el-row class="goods_category_list searchBox">
          <el-col :span="activited !== '03' ? 6 : 15">
            <el-input
              placeholder="名称/品牌/编码/型号"
              v-model.trim="dataForm.searchInput"
              clearable
              @keyup.enter.native="onSearch"
            ></el-input>
          </el-col>
          <el-col :span="6" class="screah" v-if="activited !== '03'">
            <el-input
              placeholder="平台编码"
              v-model.trim="dataForm.goodsCode"
              clearable
              @keyup.enter.native="onSearch"
            ></el-input>
          </el-col>
          <el-col :span="6" class="screah">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="resetData">重置</el-button>
          </el-col>
          <el-col :span="6" class="screah endflex"> </el-col>
        </el-row>
        <div class="el-table" ref="fakeTableHeader"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/index'
import Tooltip from '@/components/tooltip/index'
import StatusTabs from './component/statusTabs'
import { openOther } from '@/utils'
import exportFun from '@/utils/export.js'
import { formateDate } from '@/utils/formateDate'
import { formatePrice } from '@/utils/formatePrice'
import { mul, add } from '@/utils/numberComputed'

export default {
  name: 'storeStock', // 备件库查询
  components: {
    Breadcrumb,
    StatusTabs,
    Tooltip
  },
  data () {
    return {
      skuAvailableStatusOptions: [
        // 全部为1，当skuAvailableStatus 空是 转换成1
        { label: '已上架', value: 2 },
        { label: '未上架', value: 3 }
      ],
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.stockInquiry')
        }
      ],
      gotop: false,
      dataListLoading: false,
      downloadLoading: false,
      dataList: [], // 商品列表
      dataForm: {
        page: 1,
        limit: 50,
        searchInput: '',
        goodsCode: '',
        sortable: {}
      },
      choosedList: {}, // 选中商品列表 通过页码分页
      activited: '02',
      allCheck: false,
      tabList: [
        {
          key: '02',
          lable: '我的备件',
          icon: ''
        }
        // {
        // key: '03',
        // lable: '中控精选'
        // },
        // {
        // key: '01',
        //  lable: '全部备件',
        //  icon: ''
        // }
      ],
      companyList: [],
      changeCompanyList: [],
      tableConfig: {
        labelKey: 'lable',
        codeKey: 'key'
      },
      total: 0,
      isShowFakeTableHeader: false,
      account: {
        type: 0,
        num: 0,
        price: '0.00'
      },
      isShowAccountFooter: false
    }
  },
  created () {
    this.getCompanyList()
    this.bus.$on('getUserStoreSpare', this.getUserStoreSpare)
    this.initCompantList().then(() => {
      this.getGoodList()
    })

    window.addEventListener('scroll', this.checkSearchBox)
  },
  beforeDestroy () {
    this.bus.$off('getUserStoreSpare', this.getUserStoreSpare)
    window.removeEventListener('scroll', this.checkSearchBox)
  },
  beforeRouteEnter (to, from, next) {
    if (!localStorage.getItem('defaultCompanyId')) {
      next({
        name: 'home'
      })
    } else {
      next()
    }
  },

  methods: {
    getMin (m = 1, s = 1) {
      const b = Math.max(m, s)
      if (b >= m && b % s === 0) {
        return b
      } else {
        return b + (s - (b % s))
      }
    },
    // 翻页时同步数据
    changePageSetGoodsNum () {
      const p = this.choosedList[this.dataForm.page]
      if (p && p.length) {
        p.forEach((item) => {
          for (let i = 0; i < this.dataList.length; i++) {
            const goods = this.dataList[i]
            if (item.oldGoodsCode === goods.oldGoodsCode) {
              this.dataList[i].goodsNum = item.goodsNum
              break
            }
          }
        })
      }
      this.onChangeGoodsNum()
    },
    onChangeGoodsNum () {
      this.choosedList[this.dataForm.page] = this.dataList.filter(
        (i) => i.goodsNum
      )
      this.changeAccount()
    },
    changeAccount () {
      const allSelectGoods = Object.values(this.choosedList).flat(1)
      console.log(allSelectGoods)
      if (!allSelectGoods.length) {
        this.account = {
          type: 0,
          num: 0,
          price: '0.00'
        }
      }

      const type = allSelectGoods.length
      const { price, num } = allSelectGoods.reduce(
        (pre, cur) => {
          const { price, num } = pre
          const { goodsNum, price: p } = cur
          return {
            price: add(price, mul(goodsNum, p)),
            num: add(num, goodsNum)
          }
        },
        { price: 0, num: 0 }
      )

      this.account = {
        type,
        price: (+price).toFixed(4),
        num
      }
    },
    checkSearchBox () {
      if (
        !this.$refs.searchBox ||
        !this.$refs.account ||
        this.activited !== '02'
      ) {
        return
      }
      // 获取滚动条滚动的高度
      const scrollTop = document.documentElement.scrollTop
      // 获取元素偏移的高度。就是距离可视窗口的偏移量。
      const offsetTop = this.$refs.searchBox.$el.offsetTop
      // 偏移量
      const setoff = 188
      const type = offsetTop + setoff < scrollTop
      if (this.isShowFakeTableHeader !== type) {
        if (type) {
          this.cloneDom()
        }
        this.isShowFakeTableHeader = type
      }
      this.checkAccountFooter()
    },
    checkAccountFooter () {
      // 获取滚动条滚动的高度
      const scrollTop = document.documentElement.scrollTop
      //  页脚固定
      // 偏移量
      const accountOffset = 64
      const ost = (this.$refs.account && this.$refs.account.offsetTop) || 0
      const accountInWindow =
        ost > scrollTop + window.innerHeight - accountOffset
      if (this.isShowAccountFooter !== accountInWindow) {
        this.isShowAccountFooter = accountInWindow
      }
    },
    cloneDom () {
      const s = document.querySelector('.el-table__header-wrapper')
      const search = s.cloneNode(true)
      this.$refs.fakeTableHeader.innerHTML = ''
      this.$refs.fakeTableHeader.appendChild(search)
    },
    // 锚点定位，回顶部
    handleScroll () {
      let scrolltop = document.getElementsByClassName('home_page')[0].scrollTop
      scrolltop > 100 ? (this.gotop = true) : (this.gotop = false)
    },
    toTop () {
      let top = document.getElementsByClassName('home_page')[0].scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.getElementsByClassName('home_page')[0].scrollTop = top -= 200
        if (top <= 0) {
          clearInterval(timeTop)
          this.gotop = false
        }
      }, 10)
    },
    initCompantList () {
      return this.$http
        .get(
          `/front/web-shop/org-manage/v1/all-children-company/get/${this.$store.state.user.company.companyId}?authControlFlag=true`
        )
        .then(({ data: { data } }) => {
          const list = []
          this.companyList = data.map((i) => {
            const { companyId, companyName, companyRelationType } = i
            list.push(companyId)
            return {
              companyId,
              companyName: `${companyName} (${companyRelationType})`
            }
          })
        })
    },

    getCompanyList () {
      this.$http
        .get(
          `/front/webshop/personal-center/v1/children-company-list/get/${this.$store.state.user.userId}`,
          {
            params: {
              includeChildrenCompany: true // true查询当前公司所属集团的所有关联公司
            }
          }
        )
        .then(({ data: { data } }) => {
          const list = []
          this.changeCompanyList = data.map((i) => {
            const { companyId, companyName } = i
            list.push(companyId)
            return {
              companyId,
              companyName
            }
          })
        })
    },
    changeStatusHandle (val) {
      this.activited = val.key
      this.dataForm.page = 1
      this.resetData()
    },
    // 跳转共享备件详情
    goodDetailHandle (row) {
      if (!row.spuId) {
        return false
      }
      openOther(
        `sparePartsLibraryGoodDetail?spuId=${row.spuId}&skuId=${row.skuId}&custspId=${row.custspId}`
      )
    },
    // 领用/备用
    openDetailUpdate (item) {
      if (item.buttonFlag === 'BY') {
        let list = [
          {
            oldGoodsCode: item.oldGoodsCode,
            oldGoodsName: item.oldGoodsName,
            oldSpecification: item.oldSpecification,
            oldModel: item.oldModel,
            oldBrand: item.oldBrand,
            oldRemark: item.oldRemark,
            safetyStockQuantityBef: 0,
            spuId: item.spuId,
            skuId: item.skuId,
            sellingUnit: item.sellingUnit,
            safetyStockQuantity: 1 // item.safetyStockQuantity
          }
        ]
        this.$store.dispatch('setrequirementGoodsList', list)
        this.$router.push({
          name: 'spareRequirementsAdd',
          query: {
            getList: '1'
          }
        })
      } else {
        let list = [
          {
            physicalUnit: item.physicalUnit,
            physicalUnitAmount: item.physicalUnitAmount,
            oldGoodsCode: item.oldGoodsCode,
            oldGoodsName: item.oldGoodsName,
            oldSpecification: item.oldSpecification,
            oldModel: item.oldModel,
            oldBrand: item.oldBrand,
            oldRemark: item.oldRemark,
            goodsNum: 1, // item.safetyStockQuantity
            oldEdition: item.oldEdition,
            oldCongiguration: item.oldCongiguration,
            price: item.price,
            sellingUnit: item.sellingUnit,
            safetyStockQuantity: item.safetyStockQuantity,
            custspId: item.custspId
          }
        ]
        this.$store.dispatch('setLclbDataList', list)
        this.$router.push({
          name: 'spareGetAdd',
          query: {
            getList: 1
          }
        })
      }
    },
    batchAddCar () {
      const allSelectGoods = Object.values(this.choosedList).flat(1)
      let arr = allSelectGoods.map((row) => {
        return {
          goodsSpuId: row.spuId,
          goodsSkuId: row.skuId,
          goodsNum: row.goodsNum,
          custspId: row.custspId,
          shoppingType:
            this.activited === '01' && row.buttonFlag === 'BY' ? '3' : '4'
        }
      })
      this.$http
        .post('/front/consumer/shoppingcart/batchAddShoppingCart', arr)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success('添加成功')
            this.choosedList = {}
            this.$refs.multipleTable.clearSelection()
            this.getGoodList()
            this.$store.dispatch(
              'setShoppingCartCount',
              this.$store.state.shoppingCartCount + arr.length
            )
          }
        })
    },
    // 加入领用车
    joinShopCart (row) {
      if (row.skuId) {
        // 判断是否是企业站用户
        if (this.$store.state.user.corpUserInfo.customerId) {
          // 添加到企业站购物车
          this.$http.post(`/front/oms/crop-site/shopping-cart/add`,{
            custspId: row.custspId,
            skuId: row.skuId,
            goodsNum:  row.physicalUnitAmount||1,
          }).then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$store.dispatch(
              'setShoppingCartCount',
              this.$store.state.shoppingCartCount + 1
            )
            this.$message.success('加入购物车成功')
          })
          .finally(() => {
            this.loading = false
          })
          return
        }
        this.$http
          .post(`/front/consumer/shoppingcart/addShoppingCart`, {
            goodsSpuId: row.spuId,
            goodsSkuId: row.skuId,
            goodsNum: row.physicalUnitAmount || 1,
            custspId: row.custspId,
            shoppingType:
              this.activited === '01' && row.buttonFlag === 'BY' ? '3' : '4'
          })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$store.dispatch(
              'setShoppingCartCount',
              this.$store.state.shoppingCartCount + 1
            )
            this.$message.success(`加入领用车成功`)
          })
          .finally(() => {
            // this.loading = false
          })
      }
    },
    getRowKeys (row) {
      return row.skuId + '-' + row.spuId
    },
    // 一键领用
    receiveHandle () {
      if (this.dataListLoading) {
        return
      }
      const allSelectGoods = Object.values(this.choosedList).flat(1)
      if (!allSelectGoods.length) {
        return this.$message.success('请选择商品')
      }
      // 领用
      this.$store.dispatch('setLclbDataList', allSelectGoods)
      this.$router.push({
        name: 'spareGetAdd',
        query: {
          getList: 1
        }
      })
    },
    onSortChange (val) {
      const orderObj = {
        descending: 'desc',
        ascending: 'asc'
      }
      const { order, prop } = val
      this.dataForm.sortable = {
        order: orderObj[order],
        prop
      }
      this.getGoodList()
    },

    // 查询按钮
    onSearch () {
      this.dataForm.page = 1
      this.getGoodList()
    },

    getParams () {
      const { skuAvailableStatus } = this.dataForm
      return {
        companyId: this.$store.state.user.defaultCompanyId || '',
        ...this.dataForm,
        tab: this.activited,
        skuAvailableStatus: !skuAvailableStatus ? 1 : skuAvailableStatus
      }
    },
    // 获取商品列表
    getGoodList () {
      const obj = this.getParams()
      if (this.activited === '02') {
        obj.includeInvalidSku = true
      }
      this.$http
        .post(`/front/order/lclb/custsp/stockByOrdinary`, obj)
        .then(({ data }) => {
          const dataList = data.data.data || []
          dataList.some((v) => {
            if (!v.goodsNum) {
              v.goodsNum = undefined
            }
          })
          this.dataList = dataList
          this.total = Number(data.data.count) || 0
          // 是否展示固定页脚
          if (this.activited === '02') {
            this.$nextTick(() => {
              this.checkAccountFooter()
            })
            // 翻页时同步数据
            this.changePageSetGoodsNum()
          }
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    resetData () {
      this.dataForm = {
        ...this.dataForm,
        searchInput: '',
        goodsCode: ''
      }
      this.getGoodList()
    },
    getUserStoreSpare (val) {
      this.dataForm.page = 1
      this.dataForm.searchInput = val
      this.getGoodList()
    },

    // 更改当前页
    changePage (page) {
      this.dataForm.page = page
      this.getGoodList()
    },
    // 更改当前条数
    pageSizeChangeHandle (limit) {
      this.dataForm.limit = limit
      this.getGoodList()
    },
    downLoad () {
      this.downloadLoading = true
      exportFun({
        url: '/front/order/webshop/lclb/custsp/shop/exportListStockByOrdinary',
        name: `备件明细-${formateDate(
          'yyyy-MM-dd hh:mm:ss',
          new Date().getTime()
        )}.xls`,
        params: {
          appCode: window.SITE_CONFIG.appCode,
          ...this.getParams()
        },
        haveMsg: false
      }).then((t) => {
        // 操作成功
        this.downloadLoading = false
        if (t) {
          this.$message.success('下载成功')
        }
      })
    },
    formatePrice
  },
  filters: {
    isEmpty (val) {
      if (!val && val !== 0) {
        return '-'
      }
      return val
    }
  }
}
</script>

<style lang="scss" scoped>
.home_page {
  position: relative;
}
.accountBox-fixed {
  position: fixed;
  bottom: 0;
  z-index: 100;
}
.accountBox {
  border-top: 1px solid #ebeef5;
  margin-top: 12px;
  background: #fff;
  padding: 12px;
  display: flex;
  justify-content: flex-end;
  align-content: center;

  .numPrice {
    margin-right: 12px;
    display: flex;
    align-items: center;
  }
  .red {
    color: red;
    font-size: 24px;
    line-height: 24px;
  }
}
/deep/ .statusTabs .order-tab-item {
  border: 0 25px 38px 25px !important;
}
/deep/ .el-form-item {
  margin-bottom: 0;
}
// /deep/ .el-input__icon {
//   height: 30px;
//   line-height: 30px;
// }
// /deep/ .el-date-editor .el-range__icon {
//   line-height: 40px;
// }
/deep/ .el-date-editor .el-range-separator {
  line-height: 25px;
}

.home_header,
.goods_category_list {
  background: #fff;
  padding: 12px;
  padding-bottom: 0;
}
.toTop {
  width: 91px;
  height: 42px;
  background: #ffffff;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.09);
  border-radius: 51px 0px 0px 51px;
  position: fixed;
  right: 0;
  cursor: pointer;
  bottom: 74px;
  z-index: 99;
  line-height: 42px;
  text-align: center;
  // bottom: 0;
}
.good_sort {
  display: flex;
  // margin: 6px 0 20px;
  margin-bottom: 20px;
  text-align: center;
  // line-height: 56px;
  font-size: 14px;
  color: #666666;
  background: #fff;
  // border: 1px solid #e1e1e1;
  /deep/ .price_sort_option .el-input__inner {
    background-color: rgb(245, 247, 250);
    cursor: not-allowed;
  }
  .default_sort_but {
    border-radius: 4px 0px 0px 4px;
    border: 1px solid #e4e7ed;
    height: 30px;
    line-height: 30px;
  }
  .default_sort_but:hover,
  .good_sort_default {
    background: #028df9;
    border-color: #028df9;
    color: #fff;
  }
  .sort_search_input {
    /deep/ input {
      height: 30px;
      line-height: 28px;
    }
  }
  .sort_search_select {
    ::v-deep {
      .el-input__inner {
        height: 30px;
      }
      .el-input__prefix,
      .el-input__suffix {
        height: 30px;
      }
      /* 下面设置右侧按钮居中 */
      .el-input__suffix {
        top: 5px;
      }
      .el-input__icon {
        line-height: inherit;
      }
      .el-input__suffix-inner {
        display: inline-block;
      }
    }
  }
  .sort_time_box {
    height: 30px;
    line-height: 28px;
    border-radius: 0px 4px 4px 0px;
    border: 1px solid #e4e7ed;
    border-left: none;
    box-sizing: border-box;
  }
  .sort_item {
    display: flex;
    justify-content: space-around;
    align-items: center;
    // border-left: 1px solid #E4E7ED;
    .sort_status {
      margin-left: 5px;
      font-size: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #bebebe;
      .sort_status_selected {
        color: #2e88ff;
      }
    }
    .price_sort {
      display: flex;
    }
  }
  .sort_center {
    justify-content: center;
  }
}
.pagination_end {
  background-color: #fff;
  .el-pagination {
    margin-top: 0;
  }
}
.btn {
  margin-bottom: 12px;
}
.goodsImg {
  width: 60px;
  max-height: 60px;
}
.ml12 {
  margin-left: 12px;
}
.tip {
  border-radius: 50%;
  padding: 0px !important;
  width: 16px;
  height: 16px;
  font-size: 12px;
  color: #fff;
  background-color: #000;
}
.screah {
  padding-left: 12px;
}
.endflex {
  display: flex;
  justify-content: flex-end;
}
.detail {
  display: flex;
  position: relative;
  .mask {
    background: #000;
    opacity: 0.7;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
  }
  .goodsImg {
    margin-right: 12px;
    flex-shrink: 0;
  }
  .info {
    width: calc(100% - 72px);
    h3 {
      font-size: 14px;
      // width: 100%;
      // text-align: left;
      margin: 0;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 2;
      // overflow: hidden;
      // word-break: break-all;
      // text-overflow: ellipsis;
    }
    // span {
    //   text-align: left;
    //   display: block;
    //   text-overflow: ellipsis;
    //   overflow: hidden;
    //   white-space: nowrap;
    // }
  }
}
.btns {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  button {
    margin: 0;
    margin-bottom: 10px;
  }
}
.topSearch {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 100;

  ::v-deep th .el-checkbox {
    display: none;
  }
  .el-table {
    padding: 12px 12px 0 12px;
  }
  ::v-deep .sort-caret {
    display: none;
  }
}
.numInput {
  width: 100%;
}
.searchBox {
  /deep/ .el-button {
    padding: 7px 14px !important;
  }
  /deep/ .el-input__icon {
    height: 30px;
    line-height: 30px;
  }
  /deep/ .el-input__inner {
    height: 30px !important;
    line-height: 30px;
  }
}

::v-deep .el-table th {
  padding: 0;
  font-size: 14px;
}
.tooltip-wrap {
  width: 200px;
  height: 20px; // 必须要有高度设置，因为tooltip的显示条件是通过高度来判断的
  display: inline-block;
  display: -webkit-box;
  -webkit-line-clamp: 1; // 因为通过高度所以只显示一行，溢出显示省略号
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.oldGoodsName {
  cursor: pointer;
  color: #4a84b9;
}
.el-icon-question {
  color: #606266;
}
</style>
